/* eslint-disable no-unused-vars */
/* eslint-disable react/no-unknown-property */
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

// Material Kit 2 React components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";

// Reusable Components
import SubTitleContents from "reusables/TextFormats/SubTitleContents";
import UnNumberedList from "reusables/TextFormats/UnNumberedList";
import Email from "reusables/Contact/Email";

// Images

function Careers_Section1() {
  const lineSpacing_lg = <MKBox mb={12} />;
  const lineSpacing_sm = <MKBox mb={2} />;
  const secondSubTitle = (text) => (
    <MKTypography
      component="div"
      color="text"
      variant="h4"
      mt={0}
      mb={1}
      fontWeight="bold"
      sx={{ textAlign: "justify" }}
    >
      {text}
    </MKTypography>
  );

  return (
    <Container>
      <Grid
        container
        alignItems="center"
        // bgcolor={"red"}
        width={"100%"}
      >
        <Grid item xs={12}>
          <SubTitleContents
            title="Career Opportunities"
            contents={
              <>
                At Spechs, we are always looking for skilled individuals with professional cleaning
                experience who share our commitment to delivering clean and healthy environments for
                both commercial and residential spaces. As an equal opportunities employer, we place
                diversity and inclusion at the core of our policies and daily practices. By
                promoting equality, respecting human rights, and celebrating the diversity of our
                team, we continue to grow, innovate, and achieve excellence.
              </>
            }
          />
          {lineSpacing_lg}
          <SubTitleContents
            title="Apply for a Job"
            contents={
              <>
                Do you have what it takes to be a professional cleaner? Are you detail-oriented and
                focused on delivering high standards? Can you collaborate effectively within a team
                of dedicated professionals? If this sounds like you, please send your CV to{" "}
                <MKTypography component="span" color="info" fontWeight="bold">
                  <Email
                    email="admin@spechs.ie"
                    subject="Job Application: Professional Cleaner Position"
                    body="Hello, I am writing to express my interest in the professional cleaner position at your company."
                  >
                    admin@spechs.ie
                  </Email>
                </MKTypography>
                . We’ll review your application and be in touch shortly.
              </>
            }
          />
        </Grid>
      </Grid>
    </Container>
  );
}

export default Careers_Section1;
